// Только локальные растровые файлы (.png/.jpg/.jpeg) имеют webp-сиблинг foo.png.webp.
// Для svg, внешних URL и data: webp-источник не добавляем (иначе <source> 404-ит без
// отката на <img>).
const RASTER_RE = /\.(png|jpe?g)(\?.*)?$/i;

// Превращает srcSet ("a.png, b.png" или "a.png 2x") в webp-srcSet, дописывая .webp
// к каждому URL. Возвращает null, если хоть один URL не растровый локальный.
export const toWebpSrcSet = (
  srcSet: string | false | null | undefined
): string | null => {
  // ЭТАП 1 · Шаг 3 — гидрационно-безопасно: «прод ли» решает ТОЛЬКО билд-флаг
  // (import.meta.env.PROD) — одинаково на сервере и клиенте. Прежняя клиентская
  // проверка href.includes('delikateska.ru') расходилась с серверной на
  // 127.0.0.1 (прод-билд локально): сервер вставлял <source .webp>, клиент при
  // гидрации его убирал → мисматч. Семантика та же: dev-билд → null, прод-билд
  // → webp (пост-шаг post:webp генерирует .webp-соседей в dist).
  const isProduction = Boolean(
    (import.meta as unknown as { env?: { PROD?: boolean } }).env?.PROD
  );
  if (!isProduction) {
    return null; // For dev build
  }
  if (!srcSet || typeof srcSet !== 'string') {
    return null;
  }
  const parts = srcSet
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);
  const out: string[] = [];
  for (const part of parts) {
    const [url, ...desc] = part.split(/\s+/);
    if (!RASTER_RE.test(url) || url.indexOf('http') === 0) {
      return null;
    }
    out.push([`${url}.webp`, ...desc].join(' ').trim());
  }
  return out.length ? out.join(', ') : null;
};

export const webpOf = (src: string): string | null => toWebpSrcSet(src);
